import { Users, Receipt, Scale } from 'lucide-react';
import { cn } from '../../lib/utils';
import { haptics } from '../../lib/haptics';

export type TabId = 'participants' | 'expenses' | 'settlement';

interface BottomNavProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
}

const tabs: { id: TabId; label: string; icon: React.ReactNode }[] = [
  { id: 'participants', label: 'Grupo', icon: <Users className="h-5 w-5" /> },
  { id: 'expenses', label: 'Gastos', icon: <Receipt className="h-5 w-5" /> },
  { id: 'settlement', label: 'Balance', icon: <Scale className="h-5 w-5" /> },
];

export function BottomNav({ activeTab, onTabChange }: BottomNavProps) {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-background border-t border-border safe-area-bottom"
      style={{ viewTransitionName: 'bottom-nav' }}
    >
      <div className="flex justify-around items-center h-16">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => {
              haptics.light();
              onTabChange(tab.id);
            }}
            className={cn(
              'flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors',
              activeTab === tab.id
                ? 'text-primary'
                : 'text-muted-foreground hover:text-foreground'
            )}
          >
            {tab.icon}
            <span className="text-xs font-medium">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
